import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TeacherWrapperComponent } from './teacher-wrapper.component';

@NgModule({
    imports: [CommonModule, RouterModule.forChild([]), TeacherWrapperComponent],
    exports: [TeacherWrapperComponent],
    providers: [],
})
export class TeacherWrapperModule {}
